import React from "react";
import TimelineItem from "./TimelineItem";

import { useResources } from "@aetonix/hooks";

export default function BatteryLow(props) {
	const {
		localize,
	} = useResources();

	var notification = props.notification;
	var batterylow = localize("banner.batterylow", notification.from);
	var screen = props.screen;

	return (
		<TimelineItem content={batterylow} iconName="info"  notification={notification} screen={screen} />
	);
}
